import { useState, useEffect } from "react";
import { checkAvatarCache } from "@/lib/content-api";

const urlCache = new Map<string, string | null>();
const inflight = new Map<string, Promise<string | null>>();

export function useLineAvatar(
  dialogId: string,
  languageCode: string,
  speakerIndex: number,
  emotion: string,
  fallbackUrl: string | null,
): string | null {
  const cacheKey = `${dialogId}|${speakerIndex}|${emotion}`;
  const [url, setUrl] = useState<string | null>(urlCache.get(cacheKey) ?? fallbackUrl);

  useEffect(() => {
    if (urlCache.has(cacheKey)) {
      setUrl(urlCache.get(cacheKey) ?? fallbackUrl);
      return;
    }

    let cancelled = false;

    let promise = inflight.get(cacheKey);
    if (!promise) {
      promise = checkAvatarCache(dialogId, languageCode, speakerIndex, emotion)
        .then((res) => (res.status === "ready" ? res.url : null))
        .catch(() => null);
      inflight.set(cacheKey, promise);
    }

    promise.then((resolved) => {
      inflight.delete(cacheKey);
      urlCache.set(cacheKey, resolved);
      if (!cancelled) setUrl(resolved ?? fallbackUrl);
    });

    return () => { cancelled = true; };
  }, [cacheKey, dialogId, languageCode, speakerIndex, emotion, fallbackUrl]);

  return url;
}
